import {
  Directive,
  ElementRef,
  HostListener,
  Output,
  EventEmitter,
} from "@angular/core";

@Directive({
  selector: "[appTextOverflow]",
})
export class TextOverflowDirective {
  @Output() overflowed = new EventEmitter<boolean>();

  constructor(private el: ElementRef) {}

  @HostListener("window:resize")
  checkOverflow() {
    const element = this.el.nativeElement;
    const isOverflowing = element.scrollWidth - 0.01 > element.clientWidth;
    this.overflowed.emit(isOverflowing);
  }

  ngAfterViewInit() {
    this.checkOverflow();
  }
}
